/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Review, ReviewImage, SubscriptionSchedule } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class FlowerCollectionProducts<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags favorites
   * @name DeleteFlowerCollectionProductsFlowerCollectionProductIdFavorite
   * @summary お気に入りを解除する
   * @request DELETE:/flower_collection_products/{flower_collection_product_id}/favorite
   */
  deleteFlowerCollectionProductsFlowerCollectionProductIdFavorite = (
    flowerCollectionProductId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/flower_collection_products/${flowerCollectionProductId}/favorite`,
      method: "DELETE",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags flower_collection_products
   * @name GetFlowerCollectionProducts
   * @summary FLOWER COLLECTION商品を返す
   * @request GET:/flower_collection_products
   */
  getFlowerCollectionProducts = (
    query?: {
      /**
       * 商品名で検索するクエリ
       * @default null
       */
      name?: string;
      /**
       * ページ番号
       * @default "1"
       */
      page?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/flower_collection_products`,
      method: "GET",
      query: query,
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags flower_collection_products
   * @name GetFlowerCollectionProductsFavorites
   * @summary お気に入りした商品を返す
   * @request GET:/flower_collection_products/favorites
   */
  getFlowerCollectionProductsFavorites = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/flower_collection_products/favorites`,
      method: "GET",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags review_images
   * @name GetFlowerCollectionProductsFlowerCollectionProductIdReviewImages
   * @summary 商品レビューの画像一覧を返す
   * @request GET:/flower_collection_products/{flower_collection_product_id}/review_images
   */
  getFlowerCollectionProductsFlowerCollectionProductIdReviewImages = (
    flowerCollectionProductId: string,
    query?: {
      /**
       * ページ番号
       * @default 1
       */
      page?: string;
      /**
       * 1ページあたりの表示件数
       * @default null
       */
      per_page?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ReviewImage[], any>({
      path: `/flower_collection_products/${flowerCollectionProductId}/review_images`,
      method: "GET",
      query: query,
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags reviews
   * @name GetFlowerCollectionProductsFlowerCollectionProductIdReviews
   * @summary 商品レビューの一覧を返す
   * @request GET:/flower_collection_products/{flower_collection_product_id}/reviews
   */
  getFlowerCollectionProductsFlowerCollectionProductIdReviews = (
    flowerCollectionProductId: string,
    query?: {
      /**
       * ページ番号
       * @default 1
       */
      page?: string;
      /**
       * 1ページあたりの表示件数
       * @default null
       */
      per_page?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Review[], any>({
      path: `/flower_collection_products/${flowerCollectionProductId}/reviews`,
      method: "GET",
      query: query,
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags subscription_schedules
   * @name GetFlowerCollectionProductsFlowerCollectionProductIdSubscriptionSchedules
   * @summary 指定された商品の直近4つの定期便発送スケジュールを返す
   * @request GET:/flower_collection_products/{flower_collection_product_id}/subscription_schedules
   */
  getFlowerCollectionProductsFlowerCollectionProductIdSubscriptionSchedules = (
    flowerCollectionProductId: string,
    query?: {
      /**
       * 配送先の郵便番号
       * @default null
       */
      postal_code?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<SubscriptionSchedule[], void>({
      path: `/flower_collection_products/${flowerCollectionProductId}/subscription_schedules`,
      method: "GET",
      query: query,
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags flower_collection_products
   * @name GetFlowerCollectionProductsHighRating
   * @summary レビュー平均点4.5以上の商品を返す
   * @request GET:/flower_collection_products/high_rating
   */
  getFlowerCollectionProductsHighRating = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/flower_collection_products/high_rating`,
      method: "GET",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags flower_collection_products
   * @name GetFlowerCollectionProductsId
   * @summary 任意のFLOWER COLLECTION商品を返す
   * @request GET:/flower_collection_products/{id}
   */
  getFlowerCollectionProductsId = (
    id: string,
    query?: {
      /**
       * 関連するリソース
       * @default []
       */
      include?: ("in_bulk_purchasables" | "consumable_packaging_stuffs")[];
    },
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/flower_collection_products/${id}`,
      method: "GET",
      query: query,
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags flower_collection_products
   * @name GetFlowerCollectionProductsRestockable
   * @summary 再販予約可能な商品を返す
   * @request GET:/flower_collection_products/restockable
   */
  getFlowerCollectionProductsRestockable = (
    query?: {
      /**
       * ページネーションのためのカーソル
       * @default null
       */
      after?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/flower_collection_products/restockable`,
      method: "GET",
      query: query,
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags flower_collection_products
   * @name GetFlowerCollectionProductsRestockAwaited
   * @summary 再販通知予約が多い商品を返す
   * @request GET:/flower_collection_products/restock_awaited
   */
  getFlowerCollectionProductsRestockAwaited = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/flower_collection_products/restock_awaited`,
      method: "GET",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags favorites
   * @name PostFlowerCollectionProductsFlowerCollectionProductIdFavorite
   * @summary お気に入りする
   * @request POST:/flower_collection_products/{flower_collection_product_id}/favorite
   */
  postFlowerCollectionProductsFlowerCollectionProductIdFavorite = (
    flowerCollectionProductId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/flower_collection_products/${flowerCollectionProductId}/favorite`,
      method: "POST",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags resale_notifications
   * @name PostFlowerCollectionProductsFlowerCollectionProductIdResaleNotifications
   * @summary 再販通知を予約する
   * @request POST:/flower_collection_products/{flower_collection_product_id}/resale_notifications
   */
  postFlowerCollectionProductsFlowerCollectionProductIdResaleNotifications = (
    flowerCollectionProductId: string,
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/flower_collection_products/${flowerCollectionProductId}/resale_notifications`,
      method: "POST",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags stock_notifications
   * @name PostFlowerCollectionProductsFlowerCollectionProductIdStockNotifications
   * @summary 在庫通知を予約する
   * @request POST:/flower_collection_products/{flower_collection_product_id}/stock_notifications
   */
  postFlowerCollectionProductsFlowerCollectionProductIdStockNotifications = (
    flowerCollectionProductId: string,
    data: {
      /**
       * デバイストークン
       * @default null
       */
      device_token?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/flower_collection_products/${flowerCollectionProductId}/stock_notifications`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags impressions
   * @name PostFlowerCollectionProductsImpressions
   * @summary インプレッション数を増やす
   * @request POST:/flower_collection_products/impressions
   */
  postFlowerCollectionProductsImpressions = (
    data: {
      /** 商品IDの配列 */
      flower_collection_product_ids: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<any, void>({
      path: `/flower_collection_products/impressions`,
      method: "POST",
      body: data,
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags flower_collection_products
   * @name PostFlowerCollectionProductsSearch
   * @summary 商品を検索する
   * @request POST:/flower_collection_products/search
   */
  postFlowerCollectionProductsSearch = (
    data: {
      /**
       * ページネーションのためのカーソル
       * @default null
       */
      after?: string;
      /** 検索クエリ */
      query: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/flower_collection_products/search`,
      method: "POST",
      body: data,
      type: ContentType.UrlEncoded,
      ...params,
    });
}
